import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import { Badge, Divider } from '@time-line/components/common';
import {
  ProductBenefitsContainer,
  RichTextResolver,
} from 'components/common/RichTextResolver';
import type { BeforeAfterConsumerTrial } from 'types/cms/blocks';

import { CONSUMER_RESULTS_BADGE_TITLE } from './constants';

interface ConsumerResultsProps {
  results: BeforeAfterConsumerTrial['results'];
}

export function ConsumerResults({ results }: ConsumerResultsProps) {
  if (!results?.length) return null;

  return (
    <Box>
      <Badge mb="xs" w="fit-content" variant="outline" boxShadow="none" px="0">
        {CONSUMER_RESULTS_BADGE_TITLE}
      </Badge>
      <SimpleGrid columns={2} rowGap="sm" columnGap={{ base: '2xs', md: 'sm' }}>
        {results.map((row, rowIndex) => {
          const pattern = /^(\d+)%$/;
          const match = row.title.match(pattern);

          return (
            <Box
              className={`before-after_result-${rowIndex + 1}`}
              key={rowIndex}
            >
              <Box mb="3xs">
                <Text size="h3" as="span">
                  {match ? match[1] : row.title}
                </Text>
                {match && (
                  <Text size="h5" as="span" pl="2px">
                    %
                  </Text>
                )}
              </Box>
              <Divider w="full" mb="3xs" />
              <RichTextResolver
                blocks={row.description}
                container={ProductBenefitsContainer}
              />
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
}
